import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../assets/forgotPassword.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSecurityQuestion, setShowSecurityQuestion] = useState(false);
  const [securityQuestion, setSecurityQuestion] = useState('');
  const [securityAnswer, setSecurityAnswer] = useState('');
  const [securityError, setSecurityError] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSecurityError('');

    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const response = await fetch(`${baseUrl}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        // Check if security question is required
        if (data.requiresSecurityQuestion) {
          setSecurityQuestion(data.question);
          setShowSecurityQuestion(true);
        } else if (data.reset_link_sent) {
          // Success - redirect to login with success message
          navigate('/login', {
            state: {
              message: data.message || 'We have e-mailed your password reset link!'
            }
          });
        }
      } else {
        // Handle errors
        setError(data.message || 'An error occurred. Please try again.');
      }
    } catch (err) {
      console.error('Network error:', err);
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSecurityQuestionSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSecurityError('');

    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      
      // Clear any existing auth token for password reset
      const headers = {
        'Content-Type': 'application/json',
      };
      // Don't send authorization header for password reset
      
      console.log('🔧 [DEBUG] Sending security answer:', { email, answer: securityAnswer });
      
      const response = await fetch(`${baseUrl}/api/auth/forgot-password`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ email, answer: securityAnswer }),
      });

      console.log('🔧 [DEBUG] Response status:', response.status);
      
      const data = await response.json();
      console.log('🔧 [DEBUG] Response data:', data);

      if (response.ok) {
        if (data.reset_link_sent) {
          // Success - redirect to login with success message
          navigate('/login', {
            state: {
              message: data.message || 'We have e-mailed your password reset link!'
            }
          });
        }
      } else {
        // Handle errors - security answer incorrect or other issues  
        console.log('🚫 [DEBUG] Backend error:', data.message);
        setSecurityError(data.message || `Request failed with status ${response.status}`);
      }
    } catch (err) {
      console.error('Network error:', err);
      setSecurityError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (showSecurityQuestion) {
    return (
      <div className={styles.fpWrapper}>
        <div className={styles.fpCard}>
          <div className={styles.fpLogoWrap}>
            <img src="/images/logo-new.png" alt="MYGLOBE" className={styles.fpLogo} />
          </div>
          <h1 className={styles.fpTitle}>Forgot Password</h1>
          <p className={styles.fpSubtitle}>Answer your security question to continue.</p>

          <form onSubmit={handleSecurityQuestionSubmit}>
            <input type="hidden" name="email" value={email} />

            <p className={styles.fpQuestion}>{securityQuestion}</p>

            {securityError && (
              <div className={styles.fpError}>{securityError}</div>
            )}

            <div className={styles.fpInputGroup}>
              <span className={styles.fpInputIcon}>
                <i className="fa fa-key" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                name="answer"
                className={styles.fpInput}
                placeholder="Your answer"
                value={securityAnswer}
                onChange={(e) => setSecurityAnswer(e.target.value)}
                required
              />
            </div>

            <button type="submit" className={styles.fpButton} disabled={isLoading}>
              {isLoading ? 'Processing...' : 'Send Reset Link'}
            </button>
          </form>

          <div className={styles.fpFooterText}>
            Remember your password? <a href="/login" onClick={handleBackToLogin} className={styles.fpLink}>Sign in</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.fpWrapper}>
      <div className={styles.fpCard}>
        <div className={styles.fpLogoWrap}>
          <img src="/images/logo-new.png" alt="MYGLOBE" className={styles.fpLogo} />
        </div>
        <h1 className={styles.fpTitle}>Forgot Password</h1>
        <p className={styles.fpSubtitle}>Enter your email address and we'll send you a password reset link.</p>

        <form onSubmit={handleSubmit}>
          <div className={styles.fpInputGroup}>
            <span className={styles.fpInputIcon}>
              <i className="fa fa-envelope" aria-hidden="true"></i>
            </span>
            <input
              type="email"
              name="email"
              className={styles.fpInput}
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && <div className={styles.fpError}>{error}</div>}

          <button type="submit" className={styles.fpButton} disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className={styles.fpFooterText}>
          Remember your password? <a href="/login" onClick={handleBackToLogin} className={styles.fpLink}>Sign in</a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
